import { useEffect } from 'react';

/**
 * Changes the shell layout type dynamically, depending on the page for client side routing
 * @param type the shell type
 */
export function useShellLayout(type: 'shell' | 'no-shell') {
	useEffect(() => {
		if (typeof window !== 'undefined') {
			const [htmlElement] = window.document.getElementsByTagName('html');
			if (htmlElement) {
				htmlElement.dataset.pageStyle = type;
			}
		}
	}, [type]);
}
